'use client';

import { Input } from 'src/components/PulseUI';

interface DataIssuePhoneProps {
  phone: string;
  setPhone: (value: string) => void;
}

const DataIssuePhone = ({ phone, setPhone }: DataIssuePhoneProps) => {
  return (
    <div className="mt-2" data-testid="data-issue-phone">
      <label htmlFor="data-issue-phone-input" className="text-sm font-medium">
        If you found the correct phone number, please provide it below:
      </label>
      <Input
        id="data-issue-phone-input"
        type="tel"
        placeholder="Phone number"
        value={phone || ''}
        onChange={(e) => setPhone(e.target.value)}
        aria-label="Phone number"
        data-testid="data-issue-phone-input"
      />
    </div>
  );
};

export { DataIssuePhone };
